export function Navbar() {
    return (
        <div className="navbar">
            <a className="navbar-text" href="/">
                <strong>noobles studio</strong>
            </a>
        </div>
    );
}